import { render, staticRenderFns } from "./master-data-input-list.vue?vue&type=template&id=5e3aa75c&"
import script from "./master-data-input-list.vue?vue&type=script&lang=js&"
export * from "./master-data-input-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports